import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Loading
      loading: 'Loading...',

      // Home
      rsvp_button: 'RSVP HERE',
      rsvp_deadline: 'by April 28th',

      // Countdown
      days: 'days',
      hours: 'hours',
      mins: 'mins',
      secs: 'secs',

      // Details
      add_to_calendar: 'Add to Calendar',
      directions: 'Directions',
      calendar_event_title: "Sara and Gavriel's Wedding",

      // Schedule
      our_day: 'Our day',
      shuttles: 'SHUTTLES',
      from_and_to: 'From and to',
      departs: 'Departs:',
      returns: 'Returns:',
      reception: 'RECEPTION',
      venue: 'Venue',
      starts: 'Starts:',
      chuppa: 'CHUPPÀ',
      under_chuppa: 'Under the chuppà',

      // Shabbat
      shabbat_chatan: 'Shabbat Chatan',
      please_join: 'Please join us for our',
      saturday_kiddush: 'Saturday Kiddush',
      synagogue: 'Italian Synagogue',
      synagogue_address: 'Ben Yehuda 86, corner of Smolenskin, Tel Aviv-Yafo',
      from_time: 'from',
      followed_by_kiddush: 'Followed by a Kiddush',

      // Gifts
      gifts: 'Gifts',
      gifts_subtitle: 'Your presence at our wedding is the greatest gift of all.',
      gifts_description: "If you wish to honor us with a gift, we’ve created a simple way to support us as we begin building our future together.",
      contribute_credit_card: 'Send a Gift',
      thank_you: 'Thank you',

      // Euro page
      euro_title: 'Euro Bank Transfer',
      euro_beneficiary_label: 'Beneficiary',
      euro_beneficiary: 'Gavriel David Hannuna',
      euro_iban_label: 'IBAN',
      euro_iban: 'IT17 K036 6901 6004 8404 1325 874',
      euro_bic_label: 'BIC / SWIFT Code',
      euro_bic: 'REVOITM2',
      euro_bank_label: 'Bank Name and Address',
      euro_bank_name: 'Revolut Bank UAB',
      euro_bank_address: 'Via Dante 7, 20123, Milano (MI), Italy',
      euro_correspondent_label: 'Correspondent BIC',
      euro_correspondent: 'CHASDEFX',
      euro_copied: 'Copied!',
      euro_copy: 'Copy',

      // Shekel page
      shekel_bank_label: 'Bank',
      shekel_bank: 'Leumi (10)',
      shekel_beneficiary_label: 'Beneficiary',
      shekel_beneficiary: 'Gavriel David Hannuna',
      shekel_account_label: 'Account Number',
      shekel_account: '44204028',
      shekel_branch_label: 'Branch',
      shekel_branch: '882',
      shekel_bit_label: 'Bit',
      shekel_bit: '0539185133',
      shekel_copied: 'Copied!',
      shekel_copy: 'Copy',

      // Footer
      contacts: 'Contacts',
      celebrate_message: "we can't wait to celebrate with you!",
      copyright: 'All Rights Reserved | Developed by Sara Spagnoletto and Gavriel David Hannuna',

      // Header
      menu: 'Menu',
      menu_details: 'Details',
      menu_shabbat: 'Shabbat',
      menu_gifts: 'Gifts',

      // Modal
      close: 'Close',
      error_message: 'Please re-click on the link sent to you by the host.',
      thank_you_title: 'Thank you',
      look_forward: 'We look forward to celebrating with you!',
      miss_you: 'We will miss you',
      sorry_message: "We are sorry you can't make it!",
      yes: 'Yes',
      no: 'No',
      shuttle: 'Shuttle',
      shuttle_for_guests: '{{count}} guest(s) need the shuttle',
      shuttle_not_needed: 'No shuttle needed',

      // RSVP Form
      dear: 'Dear',
      confirm_presence: 'Please confirm your presence at our wedding',
      complete_form: 'Please complete the full form',
      error_rsvp: 'Error updating RSVP',
      need_shuttle: 'Need shuttle?',
      need_shuttle_people: 'How many guests need the shuttle?',
      need_shuttle_of: 'of {{count}} attending',
      cancel: 'Cancel',
      submit: 'Submit',
    }
  },
  it: {
    translation: {
      // Loading
      loading: 'Caricamento...',

      // Home
      rsvp_button: 'RSVP QUI',
      rsvp_deadline: 'entro il 28 Aprile',

      // Countdown
      days: 'giorni',
      hours: 'ore',
      mins: 'min',
      secs: 'sec',

      // Details
      add_to_calendar: 'Aggiungi al Calendario',
      directions: 'Indicazioni',
      calendar_event_title: 'Matrimonio di Sara e Gavriel',

      // Schedule
      our_day: 'Il nostro giorno',
      shuttles: 'NAVETTE',
      from_and_to: 'Andata e ritorno',
      departs: 'Partenza:',
      returns: 'Ritorno:',
      reception: 'RICEVIMENTO',
      venue: 'Location',
      starts: 'Inizio:',
      chuppa: 'CHUPPÀ',
      under_chuppa: 'Sotto la chuppà',

      // Shabbat
      shabbat_chatan: 'Shabbat Chatan',
      please_join: 'Vi invitiamo al nostro',
      saturday_kiddush: 'Kiddush del Sabato',
      synagogue: 'Tempio Italiano',
      synagogue_address: 'Ben Yehuda 86, angolo Smolenskin, Tel Aviv-Yafo',
      from_time: 'dalle',
      followed_by_kiddush: 'Seguito da un Kiddush',

      // Gifts
      gifts: 'Regali',
      gifts_subtitle: 'La vostra presenza al nostro matrimonio è il regalo più bello.',
      gifts_description: 'Se desiderate farci un ulteriore regalo, abbiamo creato un modo semplice per sostenerci mentre iniziamo a costruire il nostro futuro insieme.',
      contribute_credit_card: 'Manda un Regalo',
      thank_you: 'Grazie',

      // Euro page
      euro_title: 'Bonifico Bancario in Euro',
      euro_beneficiary_label: 'Beneficiario',
      euro_beneficiary: 'Gavriel David Hannuna',
      euro_iban_label: 'IBAN',
      euro_iban: 'IT17 K036 6901 6004 8404 1325 874',
      euro_bic_label: 'BIC / Codice SWIFT',
      euro_bic: 'REVOITM2',
      euro_bank_label: 'Nome e Indirizzo della Banca',
      euro_bank_name: 'Revolut Bank UAB',
      euro_bank_address: 'Via Dante 7, 20123, Milano (MI), Italia',
      euro_correspondent_label: 'BIC Corrispondente',
      euro_correspondent: 'CHASDEFX',
      euro_copied: 'Copiato!',
      euro_copy: 'Copia',

      // Shekel page
      shekel_bank_label: 'Banca',
      shekel_bank: 'Leumi (10)',
      shekel_beneficiary_label: 'Beneficiario',
      shekel_beneficiary: 'Gavriel David Hannuna',
      shekel_account_label: 'Numero di Conto',
      shekel_account: '44204028',
      shekel_branch_label: 'Filiale',
      shekel_branch: '882',
      shekel_bit_label: 'Bit',
      shekel_bit: '0539185133',
      shekel_copied: 'Copiato!',
      shekel_copy: 'Copia',

      // Footer
      contacts: 'Contatti',
      celebrate_message: 'non vediamo l\'ora di festeggiare con voi!',
      copyright: 'Tutti i diritti riservati | Sviluppato da Sara Spagnoletto e Gavriel David Hannuna',

      // Header
      menu: 'Menu',
      menu_details: 'Dettagli',
      menu_shabbat: 'Shabbat',
      menu_gifts: 'Regali',

      // Modal
      close: 'Chiudi',
      error_message: "Per favore, clicca di nuovo sul link che ti è stato inviato.",
      thank_you_title: 'Grazie',
      look_forward: 'Non vediamo l\'ora di festeggiare con voi!',
      miss_you: 'Ci mancherete',
      sorry_message: 'Ci dispiace che non possiate venire!',
      yes: 'Sì',
      no: 'No',
      shuttle: 'Navetta',
      shuttle_for_guests: '{{count}} ospiti in navetta',
      shuttle_not_needed: 'Navetta non necessaria',

      // RSVP Form
      dear: 'Cari',
      confirm_presence: 'Vi preghiamo di confermare la vostra presenza al nostro matrimonio',
      complete_form: 'Per favore completate il modulo',
      error_rsvp: 'Errore nell\'aggiornamento della conferma',
      need_shuttle: 'Navetta necessaria?',
      need_shuttle_people: 'Quanti ospiti hanno bisogno della navetta?',
      need_shuttle_of: 'su {{count}} partecipanti',
      cancel: 'Annulla',
      submit: 'Invia',
    }
  }
};

// Get language from URL path or default to 'en'
const getInitialLanguage = () => {
  const path = window.location.pathname;
  if (path.startsWith('/it')) return 'it';
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
